import { FC } from "react";

import { onActivateKeyDown } from "@ryde/shared";

interface IProductionLogsHubClickableCountProps {
  ids?: number[];
  count: number;
  onNavigate: (ids: number[]) => void;
  valueClassName: string;
  clickableClassName: string;
}

export const ProductionLogsHubClickableCount: FC<
  IProductionLogsHubClickableCountProps
> = ({ ids, count, onNavigate, valueClassName, clickableClassName }) => {
  if (!ids?.length) {
    return <span className={valueClassName}>{count}</span>;
  }

  return (
    <span
      className={clickableClassName}
      role="button"
      tabIndex={0}
      onClick={() => onNavigate(ids)}
      onKeyDown={onActivateKeyDown(() => onNavigate(ids))}
    >
      {count}
    </span>
  );
};
